import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IdNameString} from '@core/src/public-api';
import {registerDisplayModes, registerPatientDisplayModes} from '@modules/login/constants/register.constants';
import {configVariableValues} from '@shared/constants/config-variable-values.constants';
import {RegisterModel} from '@shared/models/register.model';
import {AppConfigService} from '@shared/services/app-config.service';
import {I18nService} from '@shared/services/i18n.service';

@Component({
  selector: 'si-register-personal-data',
  templateUrl: './register-personal-data.component.html',
  styleUrls: ['./register-personal-data.component.scss']
})
export class RegisterPersonalDataComponent implements OnInit {
  @Input() model = new RegisterModel();
  @Input() validationErrorTextIdentityDocument: string;
  @Input() wideResolution: boolean;
  @Output() modelChange = new EventEmitter<RegisterModel>();
  validationErrorTextEmailConfirm: string;
  displayModeRegisterPatient: string;
  displayModeNHC: string;
  displayModeHealthCard: string;
  languageValues: IdNameString[];
  registerDisplayModes = registerDisplayModes;
  registerPatientDisplayModes = registerPatientDisplayModes;

  constructor(
    private appConfigService: AppConfigService,
    private i18nService: I18nService
  ) {
  }

  ngOnInit(): void {
    this.getRegisterConfiguration();
    this.model.notificationLanguage = this.i18nService.getLanguage();
    this.languageValues = this.i18nService.getActiveLanguageValues();
  }

  async getRegisterConfiguration(): Promise<void> {
    await this.appConfigService.getConfigurations();
    this.displayModeRegisterPatient = this.appConfigService.getVariableValue(configVariableValues.PATIENT_REGISTRATION_MODE);
    this.displayModeNHC = this.appConfigService.getVariableValue(configVariableValues.MANDATORY_NHC_USER);
    this.displayModeHealthCard = this.appConfigService.getVariableValue(configVariableValues.MANDATORY_HEALTHCARD_USER);
  }

  onChangeEmail(): void {
    this.validateSameEmail();
  }

  onChangeEmailConfirm(): void {
    this.validateSameEmail();
  }

  validateSameEmail(): void {
    if (this.model.emailConfirm && this.model.emailConfirm !== this.model.email) {
      this.validationErrorTextEmailConfirm = 'SI_RULES_ERROR_EMAIL_DO_NOT_MATCH';
    } else {
      this.validationErrorTextEmailConfirm = null;
    }
  }

  onChangeHealthCardDocumentType(): void {
    if (!this.model.healthCardDocument.type) {
      this.model.healthCardDocument.value = null;
    }
  }
}
